import {Injectable} from '@angular/core';
import {BaseRoutes} from "../../model/enum/routes.enum";
import {Roles} from "../../model/enum/roles.enum";

@Injectable({
  providedIn: 'root',
})
export class RouteHelperServiceService {
  constructor() {}

  // @ts-ignore
  getRouteBaseOnRole(role: Roles): BaseRoutes {
    switch (role) {
      case Roles.Student:

        return BaseRoutes.StudentNew;
        // return BaseRoutes.StudentNew;
      case Roles.Methodist:
        return BaseRoutes.Methodist;
      case Roles.Curator:
        // return BaseRoutes.CuratorNew;
        return BaseRoutes.CuratorNew;
      case Roles.HeadTeacher:
        return BaseRoutes.HeadTeacher;
      case Roles.Teacher:
        return BaseRoutes.Teacher;
      case Roles.Admin:
        return BaseRoutes.Admin;
      case Roles.Manager:
        return BaseRoutes.Manager
      case Roles.InternalManager:
        return BaseRoutes.InternalManager;
    }
  }
}
